// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"vp-z","breadcrumbForward":"wp-z","breadcrumbBack":"xp-z","selected":"yp-z"};